var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtuLicensingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6B10EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18H18C17.4375 18 17 18.4688 17 19V22C17 22.5625 17.4375 23 18 23H21C21.5312 23 22 22.5625 22 22V19C22 18.4688 21.5312 18 21 18ZM20.5 21.5H18.5V19.5H20.5V21.5ZM23 9H18C17.4375 9 17 9.46875 17 10V15C17 15.5625 17.4375 16 18 16H23C23.5312 16 24 15.5625 24 15V10C24 9.46875 23.5312 9 23 9ZM22.5 14.5H18.5V10.5H22.5V14.5ZM12.5312 9.25C12.25 8.9375 11.7188 8.9375 11.4375 9.25L8.4375 12.5C8.15625 12.8125 8.15625 13.2812 8.46875 13.5625C8.625 13.6875 8.8125 13.75 9 13.75C9.1875 13.75 9.375 13.6875 9.53125 13.5312L11.25 11.6875V22.25C11.25 22.6875 11.5625 23 12 23C12.4062 23 12.75 22.6875 12.75 22.25V11.6875L14.4375 13.5312C14.7188 13.8125 15.1875 13.8438 15.5 13.5625C15.8125 13.2812 15.8125 12.8125 15.5312 12.5L12.5312 9.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtuLicensingIcon);
export default __webpack_public_path__ + "static/media/rtu-licensing-icon.480a47c524e787ef9d4f23fd18e1ff95.svg";
export { ForwardRef as ReactComponent };